import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-barcode",
  "use": "icon-barcode-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-barcode\"><path d=\"M65.7 158.7h134v703h-134zM703.3 158.7h134v703h-134zM263.4 158.7h57.4v703h-57.4zM901 158.7h57.4v703H901zM572.6 158.7h76.6v703h-76.6zM394.1 158.7H509v703H394.1z\" p-id=\"10042\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol